import React, {useState} from "react";
import 'react-calendar/dist/Calendar.css';
import { Card, CardBody, CardHeader,CardTitle, Col, Row} from "reactstrap";
import {Button, Grid, TextField, Typography, Checkbox} from "@material-ui/core";
import dayjs from 'dayjs';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material-next/Divider';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {CardActionArea, OutlinedInput, InputLabel} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/joy/Tooltip";
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import {NavLink} from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";
import CloseIcon from '@mui/icons-material/Close';
import NotificationAlert from "react-notification-alert";
// AMS code add
import ListItemText from '@mui/material/ListItemText';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';


const cardStyle={
	borderRadius:'25px',
	padding:'5px',
}

const theme = () =>
	createTheme({
	  direction: 'rtl',
	  typography: {
		fontFamily: [
		  'IranSans',
		].join(','),
	  },
	});

	const cacheRtl = createCache({
	key: 'muirtl',
	stylisPlugins: [prefixer, rtlPlugin],
	});


const useStyles = makeStyles((theme) => ({
	accordionDetails: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	video: {
		maxWidth: '100%',
		maxHeight: '100%',
		// marginRight: theme.spacing(1),
	},
}));

function EditExersice(props) {
	// AMS add for hover:
		const [hoveredCard, setHoveredCard] = useState(null);

		const handleCardHover = (cardId) => {
			setHoveredCard(cardId);
		};
	
	// AMS end code
	//AMS add for notification:
	const notificationAlertRef = React.useRef(null);
	const showNotification = (message, type) => {
		const options = {
			place: "tc",
			message: (
				<div style={{ textAlign: "center" }}>
					<div>{message}</div>
				</div>
			),
			type: type,
			icon: "tim-icons icon-bell-55",
			autoDismiss: 3,
		};
		notificationAlertRef.current.notificationAlert(options);
	};

	// AMS add for video modal :
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentVideoSource, setCurrentVideoSource] = useState('');

	const openModalVideo2 = (videoSource) => {
		setCurrentVideoSource(videoSource);
		setIsModalOpen(true);

	};

	const closeModalVideo2 = () => {
		setCurrentVideoSource('');
		setIsModalOpen(false);
	};
	//----------------------------------

	const [modalIsOpenVideo, setModalIsOpenVideo] = useState(false);
	const openModalVideo = () => {setModalIsOpenVideo(true);};
	const closeModalVideo = () => {setModalIsOpenVideo(false);};

	const [openModal, setOpenModal] = React.useState(false);
	const handleOpenModal = () => setOpenModal(true);
	const handleCloseModal = () => setOpenModal(false);

	const [openModal2, setOpenModal2] = React.useState(false);
	const handleOpenModal2 = () => setOpenModal2(true);
	const handleCloseModal2 = () => setOpenModal2(false);

	const [openModal3, setOpenModal3] = React.useState(false);
	const handleOpenModal3 = () => setOpenModal3(true);
	const handleCloseModal3 = () => setOpenModal3(false);

	const [exercises, setExercises] = React.useState([]);
	const [filterOption, setFilterOption] = React.useState();

	const [data, setData] = React.useState();

	// var exercises_temp = null

	//for api
	useEffect(() => {
		// Fetch the sessions
		axios.get(`https://back.actelmon.ir/api/doctor/getsearchfield`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				setFilterOption(response.data)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});

	}, []);

	//for api
	useEffect(() => {
		// Fetch the sessions
		axios.get(`https://back.actelmon.ir/api/doctor/sessionsdetail2/${Cookies.get('sessionID')}/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {

				setData(response.data)
				setSelectedCards(response.data.prescription)

				// save the time and date
				const d = new Date(response.data.date + "T" + response.data.time)
				const min = d.getMinutes().toString()
				const hour = d.getHours().toString()
				var date = d.toLocaleDateString().toString().split('/')
				date = date[2] +"-"+ date[0] +"-"+ date[1]
				date = convertToSolar(date).split("/")
				setSelectedHour(hour)
				setSelectedMinute(min)
				setSelectedYear(date[0])
				setSelectedMonth(date[1])
				setSelectedDay(date[2].startsWith('0') ? date[2].substring(1) : date[2])
				// AMS code
				setNote(response.data.description)

				// Extract and save the sets, repeat, totalTime, holdTime, and restTime
				const extractedSets = [];
				const extractedRepeat = [];
				const extractedTotalTime = [];
				const extractedHoldTime = [];
				const extractedRestTime = [];
				const exercisestemp = [];

				response.data.prescription.forEach((prescription, index) => {
					extractedSets.push(prescription.sets);
					extractedRepeat.push(prescription.repeat);
					extractedTotalTime.push(prescription.total_time);
					extractedHoldTime.push(prescription.hold_time);
					extractedRestTime.push(prescription.rest_time);
					exercisestemp.push(prescription);
				});

				setSets(extractedSets);
				setRepeat(extractedRepeat);
				setTotalTime(extractedTotalTime);
				setHoldTime(extractedHoldTime);
				setRestTime(extractedRestTime);
				setExercises(exercisestemp);

				const x = {prescription : response.data.prescription}
				setPrescriptionData(x)

			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});

	}, []);

	const handleClickExersice = (target) => {
		// Fetch the sessions
		axios.get(`https://back.actelmon.ir/api/doctor/exercisesorgan?organ_id=${target}`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				setExercises(response.data)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
		setOpenModal(false);
		setOpenModal2(true);
	}

	const englishToPersianNumbers = (input) => {
		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};

	const englishToPersianNumbersForDateTime = (input) => {
		//if input is undefined return
		if (input === undefined) return input;
		//if input is null return
		if (input === null) return input;
	
		//if len input is 0 return
		if (input.length === 0) return input;
		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		const digitMapSingle = {
			'0': '۰۰',
			'1': '۰۱',
			'2': '۰۲',
			'3': '۰۳',
			'4': '۰۴',
			'5': '۰۵',
			'6': '۰۶',
			'7': '۰۷',
			'8': '۰۸',
			'9': '۰۹',
		};

		// Convert numbers in the input to Persian numbers
		let convertedString;
		if (input.toString().length == 1)
		{
		convertedString = input.toString().replace(/\d/g, (digit) => digitMapSingle[digit] || digit);

		}else{
		convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);
		}
		return convertedString;
	};

	const persianToEnglishNumbers = (input) => {
		if (typeof input !== 'string') {
			console.error('Input must be a string');
			return input;
		}

		// Define a mapping of Persian digits to English digits
		const digitMap = {
			'۰': '0',
			'۱': '1',
			'۲': '2',
			'۳': '3',
			'۴': '4',
			'۵': '5',
			'۶': '6',
			'۷': '7',
			'۸': '8',
			'۹': '9',
		};

		// Convert Persian numbers in the input to English numbers
		const convertedString = input.replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolar = (gregorianDate) => {
		// split gregorianDate with -
		let parts = gregorianDate.split('-');
		let date = new Date(parts[0], parts[1] - 1, parts[2]);
		return convertgregorianToSolar(date)
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		return solarDate;
	};

	function gregorianToJalali(gy, gm, gd) {
		const g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
		let jy = (gy <= 1600) ? 0 : 979;
		gy -= (gy <= 1600) ? 621 : 1600;
		let gy2 = (gm > 2) ? (gy + 1) : gy;
		let days = (365 * gy) + Math.floor((gy2 + 3) / 4) - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400) - 80 + gd + g_d_m[gm - 1];
		jy += 33 * Math.floor(days / 12053);
		days %= 12053;
		jy += 4 * Math.floor(days / 1461);
		days %= 1461;
		if (days > 365) {
			jy += Math.floor((days - 1) / 365);
			days = (days - 1) % 365;
		}
		let jm = (days < 186) ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
		let jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
		return [jy, jm, jd];
	}
		
	const convertgregorianToSolar=(date) =>{
		let gy = date.getFullYear();
		console.log(gy)
		let gm = date.getMonth() + 1;
		console.log(gm)
		let gd = date.getDate();
		console.log(gd)
		let jalaliDate = gregorianToJalali(gy, gm, gd);
		return jalaliDate[0]+"/"+jalaliDate[1]+"/"+jalaliDate[2]
	};

	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	const styleModal = {
		// position: 'absolute',
		// top: '50%',
		// left: '50%',
		// transform: 'translate(-50%, -50%)',
		// width: 1000,
		// bgcolor: '#f3f3f3',
		// borderRadius: '20px',
		// boxShadow: 24,
		// p: 4,
	};

	const images = [
		{
			url: require("assets/img/Exersice/آرنج.jpg"),
			title: 'آرنج',
			width: '24%',
			target: 1,
		},
		{
			url: require("assets/img/Exersice/زانو.jpg"),
			title: 'زانو',
			width: '24%',
			target: 2,
		},
		{
			url: require("assets/img/Exersice/شانه.jpg"),
			title: 'شانه',
			width: '24%',
			target: 3,
		},
		{
			url: require("assets/img/Exersice/شکم.jfif"),
			title: 'شکم',
			width: '24%',
			target: 4,
		},
		{
			url: require("assets/img/Exersice/فک.png"),
			title: 'فک',
			width: '24%',
			target: 5,
		},
		{
			url: require("assets/img/Exersice/قفسه_سینه.jpg"),
			title: 'قفسه سینه',
			width: '24%',
			target: 6,
		},
		{
			url: require("assets/img/Exersice/لگن.jpg"),
			title: 'لگن',
			width: '24%',
			target: 7,
		},
		{
			url: require("assets/img/Exersice/مفصل_ران.jpg"),
			title: 'مفصل ران',
			width: '24%',
			target: 8,
		},
		{
			url: require("assets/img/Exersice/مچ_دست.jpg"),
			title: 'مچ دست',
			width: '24%',
			target: 9,
		},
		{
			url: require("assets/img/Exersice/مچ_پا.jpg"),
			title: 'مچ پا',
			width: '24%',
			target: 10,
		},
		{
			url: require("assets/img/Exersice/thoracic.jpg"),
			title: 'توراسیک',
			width: '24%',
			target: 11,
		},
		{
			url: require("assets/img/Exersice/کتف.jpg"),
			title: 'کتف',
			width: '24%',
			target: 12,
		},
		{
			url: require("assets/img/Exersice/کمر.jpg"),
			title: 'کمر',
			width: '24%',
			target: 13,
		},
		{
			url: require("assets/img/Exersice/گردن.jpg"),
			title: 'گردن',
			width: '24%',
			target: 14,
		},
	];

	const ImageButton = styled(ButtonBase)(({ theme }) => ({
		position: 'relative',
		height: 120,
		[theme.breakpoints.down('sm')]: {
			width: '100% !important', // Overrides inline-style
			height: 100,
		},
		'&:hover, &.Mui-focusVisible': {
			zIndex: 1,
			'& .MuiImageBackdrop-root': {
				opacity: 0.15,
			},
			'& .MuiImageMarked-root': {
				opacity: 0,
			},
			'& .MuiTypography-root': {
				border: '2px solid currentColor',
				padding: '5px',
				borderRadius:'10px'
			},
		},
	}));

	const ImageSrc = styled('span')({
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		backgroundSize: 'cover',
		backgroundPosition: 'center 40%',
	});

	const Image = styled('span')(({ theme }) => ({
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: theme.palette.common.white,
	}));

	const ImageBackdrop = styled('span')(({ theme }) => ({
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		backgroundColor: theme.palette.common.black,
		opacity: 0.4,
		transition: theme.transitions.create('opacity'),
	}));

	const ImageMarked = styled('span')(({ theme }) => ({
		height: 3,
		width: 18,
		backgroundColor: theme.palette.common.white,
		position: 'absolute',
		bottom: -2,
		left: 'calc(50% - 9px)',
		transition: theme.transitions.create('opacity'),
	}));

const [move, setMove] = React.useState([]);
	const [target, setTarget] = React.useState([]);
	const [position, setPosition] = React.useState([]);
	const [equipment, setEquipment] = React.useState('');


	// AMS change handler code

	const handleChangeMove = (event) => {
		console.log(event);
	  const {
		target: { value },
	  } = event;
	  setMove(
		typeof value === 'string' ? value.split(', ') : value

	  );
	};

	const handleChangeTarget = (event) => {
		console.log(event);
	  const {
		target: { value },
	  } = event;
	  setTarget(
		typeof value === 'string' ? value.split(', ') : value

	  );
	};

	const handleChangePosition = (event) => {
		console.log(event);
	  const {
		target: { value },
	  } = event;
	  setPosition(
		typeof value === 'string' ? value.split(', ') : value

	  );
	};
	const handleChangeEquipment = (event) => {
		console.log(event);
	  const {
		target: { value },
	  } = event;
	  setEquipment(
		typeof value === 'string' ? value.split(', ') : value

	  );
	};

	// AMS end code


	const [exersiceForm, setExersiceForm] = React.useState('');
	const handleChangeExersiceForm = (event) => {setExersiceForm(event.target.value)};

	const [selectedCards, setSelectedCards] = useState([]);
	const [patientID, setPatientID] = useState(Cookies.get('patientID'));

	const handleCardClick = (id) => {
		setSelectedCards((prevSelectedCards) => {
			const isCardSelected = prevSelectedCards.some((card) => card.id === id);
	
			if (isCardSelected) {
				// If card is already selected, remove it from the selectedCards array
				return prevSelectedCards.filter((card) => card.id !== id);
			} else {
				// If card is not selected, add it to the selectedCards array
				const clickedCard = filteredExercises.find((card) => card.id === id);
				return [...prevSelectedCards, clickedCard];
			}
		});
	};
	
	const isCardSelected = (id) => {
		return selectedCards.some((card) => card.id === id);
	};

	const handleDeleteExercise = (id, index) => {
		setSelectedCards((prevSelectedCards) => {
			return prevSelectedCards.filter((card) => card.id !== id);
		});
		setPrescriptionData((prevData) => {
			let newData = {...prevData}
			newData.prescription = newData.prescription.filter((item) => item.id !== id);
			return newData;

		});



		setHoldTime((prevData)=>{
			const newData = prevData.filter((_, i) => i !== index);
			return newData
		})

		setRepeat((prevData)=>{
			const newData = prevData.filter((_, i) => i !== index);
			return newData

		})
		setRestTime((prevData)=>{
			const newData = prevData.filter((_, i) => i !== index);
			return newData

		})
		setSets((prevData)=>{
			const newData = prevData.filter((_, i) => i !== index);
			return newData

		})
		setTotalTime((prevData)=>{
			const newData = prevData.filter((_, i) => i !== index);
			return newData

		})

		


	};

	const classes = useStyles();

	const [isVideoPlaying, setIsVideoPlaying] = useState(false);
	const handleStartVideo = () => {setIsVideoPlaying(true);};
	const handlePauseVideo = () => {setIsVideoPlaying(false);};

	const [belowPage, setBelowPage] = React.useState(true);
	const handleChangeBelowPage = () => {setBelowPage(!belowPage)};

	const [selectedDateTime, setSelectedDateTime] = useState(dayjs('2022-04-17T15:30'));
	const [sessionType, setSessionType] = useState('online');
	const [note, setNote] = useState();

	const [sets, setSets] = useState([]);
	const [repeat, setRepeat] = useState([]);
	const [totalTime, setTotalTime] = useState([]);
	const [holdTime, setHoldTime] = useState([]);
	const [restTime, setRestTime] = useState([]);

	const [searchTerm, setSearchTerm] = useState('');


	// for keep sync between states and prescriptions:
	// const updatePrescriptionData = (index, updatedFields) => {
	// 	setPrescriptionData((prevData) => {
	// 	  const newData = { ...prevData };
	// 	  newData.prescription[index] = {
	// 		...newData.prescription[index],
	// 		sets: updatedFields.sets ?? sets[index],
	// 		repeat: updatedFields.repeat ?? newData.prescription[index].repeat,
	// 		hold_time: updatedFields.hold_time ?? newData.prescription[index].hold_time,
	// 		total_time: updatedFields.total_time ?? newData.prescription[index].total_time,
	// 		rest_time: updatedFields.rest_time ?? newData.prescription[index].rest_time,
	// 	  };
	// 	  console.log(newData)
	// 	  return newData;
	// 	});
	//   };
	

	const handleSetsChange = (event, index) => {
		const newSets = [...sets]; // Create a copy of the original array
		newSets[index] = event; // Update the value at the specified index
		setSets(newSets); // Set the state with the updated array
	};
	const handleRepeatChange = (event, index) => {
		const newSets = [...repeat]; // Create a copy of the original array
		newSets[index] = event; // Update the value at the specified index
		setRepeat(newSets); // Set the state with the updated array
	};
	const handleTotalChange = (event, index) => {
		const newSets = [...totalTime]; // Create a copy of the original array
		newSets[index] = event; // Update the value at the specified index
		setTotalTime(newSets); // Set the state with the updated array
	};
	const handleRestChange = (event, index) => {
		const newSets = [...restTime]; // Create a copy of the original array
		newSets[index] = event; // Update the value at the specified index
		setRestTime(newSets); // Set the state with the updated array
	};
	const handleHoldChange = (event, index) => {
		const newSets = [...holdTime]; // Create a copy of the original array
		newSets[index] = event; // Update the value at the specified index
		setHoldTime(newSets); // Set the state with the updated array
	};

	const [prescriptionData, setPrescriptionData] = useState({
		prescription: [],
	});

	const handleSet = (index) => (event) => {
		setPrescriptionData((prevData) => {
			const newData = { ...prevData };
			newData.prescription[index] = {
				...selectedCards[index],
				sets: event,
				repeat: repeat[index],
				hold_time: holdTime[index],
				total_time: totalTime[index],
				rest_time: restTime[index],
			};

			return newData;
		});
	};
	const handleRepeat = (index) => (event) => {
		setPrescriptionData((prevData) => {
			const newData = { ...prevData };
			newData.prescription[index] = {
				...selectedCards[index],
				sets: sets[index],
				repeat: event,
				hold_time: holdTime[index],
				total_time: totalTime[index],
				rest_time: restTime[index],
			};
			return newData;
		});
	};
	const handleHold = (index) => (event) => {
		setPrescriptionData((prevData) => {
			const newData = { ...prevData };
			newData.prescription[index] = {
				...selectedCards[index],
				sets: sets[index],
				repeat: repeat[index],
				hold_time: event,
				total_time: totalTime[index],
				rest_time: restTime[index],
			};
			return newData;
		});
	};
	const handleTotal = (index) => (event) => {
		setPrescriptionData((prevData) => {
			const newData = { ...prevData };
			newData.prescription[index] = {
				...selectedCards[index],
				sets: sets[index],
				repeat: repeat[index],
				hold_time: holdTime[index],
				total_time: event,
				rest_time: restTime[index],
			};
			return newData;
		});
	};
	const handleRest = (index) => (event) => {
		setPrescriptionData((prevData) => {
			const newData = { ...prevData };
			newData.prescription[index] = {
				...selectedCards[index],
				sets: sets[index],
				repeat: repeat[index],
				hold_time: holdTime[index],
				total_time: totalTime[index],
				rest_time: event,
			};
			return newData;
		});
	};

	const handleSendToAPI = () => {
		let emptyFlag = 1;

		const formData = new FormData();

		// Assuming prescriptionData.prescription and exercise arrays have the same length and order

		const updatedPrescription = prescriptionData.prescription.map((prescriptionItem, index) => {

			Object.keys(prescriptionItem).forEach(function(key){
				if (prescriptionItem[key] === "") {
				  delete prescriptionItem[key];
				}
			  });

			const x = selectedCards[index].id
			const y = [{id : x}]
		
			// Check if sets or repeat fields are empty
			if (!prescriptionItem.sets || !prescriptionItem.repeat) {
				emptyFlag = 0;
			}
			return {
				...prescriptionItem,
				id: x,
				exercises: y,
			};
		});

		const requestData = {
			date: selectedYear + '-' + selectedMonth + '-' + selectedDay, // Format the date to match the expected format
			time: selectedHour + ':' + selectedMinute, // Format the time to match the expected format
			session_type: sessionType,
			status: "p", // You may adjust the value as needed
			rate: 0, // You may adjust the value as needed
			description: note,
			prescription: updatedPrescription, // Extract the prescription array from prescriptionData
			// prescription: prescriptionData.prescription, // Extract the prescription array from prescriptionData
		};

		console.log("==========-------------===============")
		console.log(requestData)

		// Send the post request
		if (emptyFlag === 1){
				showNotification("در انتظار پاسخ از سامانه، لطفا منتظر بمانید", "info");
			axios.put(`https://back.actelmon.ir/api/doctor/update_session_with_prescriptions/${patientID}/sessions/${Cookies.get('sessionID')}/`, requestData, {
				headers: {
					Authorization: `${Cookies.get('token')}`,
					'Content-Type': 'application/json', // Specify the content type as JSON
				},
			})
				.then((response) => {

					// Handle success if needed
					window.location.href = '/rtl/patientprofile'
				})
				.catch((error) => {
					showNotification("لطفا تمامی فیلدهای مورد نیاز را تکمیل کنید", "danger");

					console.log('Data newExersice', error)
					console.error('Error fetching data newExersice:', error);
				});
			}else{
				showNotification("لطفا تما فیلد‌های مربوط به ست و تکرار را پر کنید", "danger");

			}

	};

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};

	const handleConfTime = () => {
		// Combine the separate variables into a Date object
		const object = new Date(selectedYear, selectedMonth, selectedDay, selectedHour, selectedMinute);

		// Convert the Date object to a Day.js object
		const dayjsObject = dayjs(object);
		var date= dayjsObject.format('YYYY-MM-DD')
		var time= dayjsObject.format('HH:mm')

		handleCloseModal3()
	};

	const filteredExercises = ( searchTerm || position || equipment || target || move ) ? exercises.filter((item) => {
		const values = item.name.toLowerCase();
		return values.includes(searchTerm.toLowerCase());
	}).filter(item => !position.length || position.every(pos => item.placement_position.includes(pos)))
	  .filter(item => !equipment.length || equipment.every(equip => item.accessories.includes(equip)))
	  .filter(item => !target.length || target.every(tar => item.target.includes(tar)))
	  .filter(item => !move.length || move.every(mov => item.displacement.includes(mov))): exercises;


	  function koseSher() {
		setSearchTerm('')
		setPosition([])
		setMove([])
		setEquipment([])
		setTarget([])
	}

	// Function to generate an array of years (adjust the range as needed)
	const generateDays = () => {
		const days = [];
		for (let i = 1; i <= 31; i++) {
			days.push(i);
		}
		return days;
	};

	const gregorianMonths = {
		'01': 'فروردین',
		'02': 'اردیبهشت',
		'03': 'خرداد',
		'04': 'تیر',
		'05': 'مرداد',
		'06': 'شهریور',
		'07': 'مهر',
		'08': 'آبان',
		'09': 'آذر',
		'10': 'دی',
		'11': 'بهمن',
		'12': 'اسفند',
	}
	const monthsArray = Object.entries(gregorianMonths).map(([key, value]) => ({
		value: key,
		label: value,
	}));

	const [selectedYear, setSelectedYear] = useState('');
	const handleYearChange = (event) => { setSelectedYear(event.target.value) };

	const [selectedMonth, setSelectedMonth] = useState('');
	const handleMonthChange = (event) => { setSelectedMonth(event.target.value) };

	const [selectedDay, setSelectedDay] = useState('');
	const handleDayChange = (event) => { setSelectedDay(event.target.value) };

	const generateHour = () => {
		const days = [];
		for (let i = 0; i <= 23; i++) {
			days.push(i);
		}
		return days;
	};

	const generateMin = () => {
		const days = [];
		for (let i = 0; i <= 59; i++) {
			days.push(i);
		}
		return days;
	};

	const [selectedHour, setSelectedHour] = useState('');
	const handleHourChange = (event) => { setSelectedHour(event.target.value) };

	const [selectedMinute, setSelectedMinute] = useState('');
	const handleMinuteChange = (event) => { setSelectedMinute(event.target.value) };

	const generateYears = () => {
		const years = [];
		for (let i = 1402; i <= 1408; i++) {
			years.push(i);
		}
		return years;
	};

	// AMS code to apply to all or selected

	const [selectedIndices, setSelectedIndices] = useState([]);

	const [globalSetsValue, setGlobalSetsValue] = useState('');
	const [globalRepeatValue, setGlobalRepeatValue] = useState('');
	const [globalTotalTimeValue, setGlobalTotalTimeValue] = useState('');
	const [globalHoldTimeValue, setGlobalHoldTimeValue] = useState('');
	const [globalRestTimeValue, setGlobalRestTimeValue] = useState('');

	const [selectAllChecked, setSelectAllChecked] = useState(false);

	const applyToAll = (newParams) => {

		const isChecked = true;
        setSelectAllChecked(isChecked);
        setSelectedIndices(isChecked ? selectedCards.map((_, index) => index) : []);

		let indexes = selectedCards.map((_, index) => index);


		const newSets = sets.length ? [...sets] : [];
		const newRepeats = repeat.length ? [...repeat] : [];
		const newTotalTimes = totalTime.length ? [...totalTime] : [];
		const newHoldTimes = holdTime.length ? [...holdTime] : [];
		const newRestTimes = restTime.length ? [...restTime] : [];

	
		indexes.forEach((item) => {
			newSets[item] = newParams.sets;
			newRepeats[item] = newParams.repeat;
			newTotalTimes[item] = newParams.total_time;
			newHoldTimes[item] = newParams.hold_time;
			newRestTimes[item] = newParams.rest_time;
		});
	
		// Update all states at once
		setSets(newSets);
		setRepeat(newRepeats);
		setTotalTime(newTotalTimes);
		setHoldTime(newHoldTimes);
		setRestTime(newRestTimes);
	
		// Update prescriptionData
		setPrescriptionData((prevData) => {
			const newPrescription = prevData.prescription.map((item, index) => {
				if (indexes.includes(index)) {
					return {
						...selectedCards[index],
						sets: newParams.sets,
						repeat: newParams.repeat,
						hold_time: newParams.hold_time,
						total_time: newParams.total_time,
						rest_time: newParams.rest_time,
					};
				}
				return item;
			});
	
			// If prescription data for a selected index doesn't exist, add it
			indexes.forEach((index) => {
				if (!newPrescription[index]) {
					newPrescription[index] = {
						...selectedCards[index],
						sets: newParams.sets,
						repeat: newParams.repeat,
						hold_time: newParams.hold_time,
						total_time: newParams.total_time,
						rest_time: newParams.rest_time,
					};
				}
			});
	
			return {
				...prevData,
				prescription: newPrescription,
			};
		});
	}
	
	
	const applyToSelected = (newParams) => {
		// Create new arrays for the updates, initialize empty arrays if not defined
		const newSets = sets.length ? [...sets] : [];
		const newRepeats = repeat.length ? [...repeat] : [];
		const newTotalTimes = totalTime.length ? [...totalTime] : [];
		const newHoldTimes = holdTime.length ? [...holdTime] : [];
		const newRestTimes = restTime.length ? [...restTime] : [];

	
		selectedIndices.forEach((item) => {
			newSets[item] = newParams.sets;
			newRepeats[item] = newParams.repeat;
			newTotalTimes[item] = newParams.total_time;
			newHoldTimes[item] = newParams.hold_time;
			newRestTimes[item] = newParams.rest_time;
		});
	
		// Update all states at once
		setSets(newSets);
		setRepeat(newRepeats);
		setTotalTime(newTotalTimes);
		setHoldTime(newHoldTimes);
		setRestTime(newRestTimes);
	
		// Update prescriptionData
		setPrescriptionData((prevData) => {
			const newPrescription = prevData.prescription.map((item, index) => {
				if (selectedIndices.includes(index)) {
					return {
						...selectedCards[index],
						sets: newParams.sets,
						repeat: newParams.repeat,
						hold_time: newParams.hold_time,
						total_time: newParams.total_time,
						rest_time: newParams.rest_time,
					};
				}
				return item;
			});
	
			// If prescription data for a selected index doesn't exist, add it
			selectedIndices.forEach((index) => {
				if (!newPrescription[index]) {
					newPrescription[index] = {
						...selectedCards[index],
						sets: newParams.sets,
						repeat: newParams.repeat,
						hold_time: newParams.hold_time,
						total_time: newParams.total_time,
						rest_time: newParams.rest_time,
					};
				}
			});
	
			return {
				...prevData,
				prescription: newPrescription,
			};
		});
	};

	const handleSelectAllChange = (event) => {
        const isChecked = event.target.checked;
        setSelectAllChecked(isChecked);
        setSelectedIndices(isChecked ? selectedCards.map((_, index) => index) : []);
    };

	return (
		<>
			<NotificationAlert ref={notificationAlertRef} />

			{/*AMS ADD VIDEO MODAL*/}
			<Modal
				open={isModalOpen}
				onClose={closeModalVideo2}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				onContextMenu={(e) => e.preventDefault()} // Disable right-click

				>
				  <Box sx={styleModal} className="wrapModal">
					{/* Exit Icon Button */}
					<IconButton
					  edge="end"
					  color="inherit"
					  onClick={closeModalVideo2}
					  aria-label="close"
					  sx={{
						position: 'absolute',
						top: 3,
						right: 10,
					  }}
					>
					  <CloseIcon />
					</IconButton>
			
					{/* Video */}
					<video
						autoPlay
						className={classes.video}
						src={currentVideoSource}
						style={{
							width: '100%', // Set the width of the video to 100%
							height: '100%', // Set the height of the video to 100%
						}}
					/>
				</Box>

			</Modal>

			{/*Modal1*/}
			<Modal
				open={openModal}
				onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={styleModal} className="wrapModal">
				<i className="tim-icons icon-simple-remove p-4 mt-2 font-weight-bold position-absolute close-modal"
                onClick={handleCloseModal}></i>
					<div className="d-flex flex-wrap justify-content-start align-items-center" style={{ height: "500px" }}>

					{images.map((image) => (
						<ImageButton
							focusRipple
							key={image.title}
							style={{
								width: image.width,
								margin:'4px',
								borderRadius:'10px',
							}}
							onClick={() => handleClickExersice(image.target)}
						>
							<ImageSrc style={{ backgroundImage: `url(${image.url})`, borderRadius:'10px',}} />
							<ImageBackdrop className="MuiImageBackdrop-root" style={{ borderRadius:'10px',}} />
							<Image>
								<Typography
									component="span"
									variant="subtitle1"
									color="inherit"
									sx={{
										position: 'relative',
										p: 4,
										pt: 2,
										pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
									}}
								>
									{image.title}
									<ImageMarked className="MuiImageMarked-root" />
								</Typography>
							</Image>
						</ImageButton>
					))}
					</div>
				</Box>
			</Modal>

			{/*Modal2*/}
			<Modal
				open={openModal2}
				onClose={handleCloseModal2}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={styleModal} className="wrapModal">
				<i className="tim-icons icon-simple-remove p-4 mt-2 font-weight-bold position-absolute close-modal"
                onClick={handleCloseModal2}></i>
				<Row lg="12" sm="12" style={{padding:'5px'}}>
						<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">


							<Grid item lg={3} xs={12}>
							<CacheProvider value={cacheRtl}>
							<ThemeProvider theme={theme}>
								<FormControl fullWidth>
								<InputLabel id="demo-multiple-checkbox-label">نوع حرکت</InputLabel>
								<Select
								labelId="demo-multiple-checkbox-label"
								id="demo-multiple-checkbox"
								multiple
								value={move}
								onChange={handleChangeMove}
								input={<OutlinedInput label="نوع حرکت" />}
								renderValue={(selected) => {
									return selected.map(
										(val) => {
											var name = filterOption.movments.find(
												item=> {return item.id === val}
											)
											return name.name
								
									}
									).join(', ')
								}}
								// MenuProps={MenuProps}
								>
								{filterOption ? filterOption.movments.map((item,index)  => (
									<MenuItem key={item.name} value={item.id}>
									<Checkbox checked={move.indexOf(item.id) > -1} />
									<ListItemText primary={item.name} />
									</MenuItem>
								)): (
									<MenuItem key={-1} value={-1}></MenuItem>
								)}
								</Select>
							</FormControl>
							</ThemeProvider>
							</CacheProvider>
							</Grid>


							<Grid item lg={3} xs={12} >
							<CacheProvider value={cacheRtl}>
							<ThemeProvider theme={theme}>
								<FormControl fullWidth>
								<InputLabel id="demo-multiple-checkbox-label">هدف</InputLabel>
								<Select
								labelId="demo-multiple-checkbox-label"
								id="demo-multiple-checkbox"
								multiple
								value={target}
								onChange={handleChangeTarget}
								input={<OutlinedInput label="هدف" />}
								renderValue={(selected) => {
									return selected.map(
										(val) => {
											var name = filterOption.objectives.find(
												item=> {return item.id === val}
											)
											return name.name
								
									}
									).join(', ')
								}}
								// MenuProps={MenuProps}
								>
								{filterOption ? filterOption.objectives.map((item,index)  => (
									<MenuItem key={item.name} value={item.id}>
									<Checkbox checked={target.indexOf(item.id) > -1} />
									<ListItemText primary={item.name} />
									</MenuItem>
								)): (
									<MenuItem key={-1} value={-1}></MenuItem>
								)}
								</Select>
							</FormControl>
							</ThemeProvider>
							</CacheProvider>
							</Grid>


							<Grid item lg={3} xs={12}>
							<CacheProvider value={cacheRtl}>
							<ThemeProvider theme={theme}>
								<FormControl fullWidth>
								<InputLabel id="demo-multiple-checkbox-label">نحوه قرارگیری</InputLabel>
								<Select
								labelId="demo-multiple-checkbox-label"
								id="demo-multiple-checkbox"
								multiple
								value={position}
								onChange={handleChangePosition}
								input={<OutlinedInput label="نحوه قرارگیری" />}
								renderValue={(selected) => {
									return selected.map(
										(val) => {
											var name = filterOption.position.find(
												item=> {return item.id === val}
											)
											return name.name
								
									}
									).join(', ')
								}}
								// MenuProps={MenuProps}
								>
								{filterOption ? filterOption.position.map((item,index)  => (
									<MenuItem key={item.name} value={item.id}>
									<Checkbox checked={position.indexOf(item.id) > -1} />
									<ListItemText primary={item.name} />
									</MenuItem>
								)): (
									<MenuItem key={-1} value={-1}></MenuItem>
								)}
								</Select>
							</FormControl>
							</ThemeProvider>
							</CacheProvider>
							</Grid>


							<Grid item lg={3} xs={12}>
							<CacheProvider value={cacheRtl}>
							<ThemeProvider theme={theme}>
								<FormControl fullWidth>
								<InputLabel id="demo-multiple-checkbox-label">تجهیزات</InputLabel>
								<Select
								labelId="demo-multiple-checkbox-label"
								id="demo-multiple-checkbox"
								multiple
								value={equipment}
								onChange={handleChangeEquipment}
								input={<OutlinedInput label="تجهیزات" />}
								renderValue={(selected) => {
									return selected.map(
										(val) => {
											var name = filterOption.equipments.find(
												item=> {return item.id === val}
											)
											return name.name
								
									}
									).join(', ')
								}}
								// MenuProps={MenuProps}
								>
								{filterOption ? filterOption.equipments.map((item,index)  => (
									<MenuItem key={item.name} value={item.id} dir="rtl">
									<Checkbox checked={equipment.indexOf(item.id) > -1} />
									<ListItemText primary={item.name} dir="rtl"/>
									</MenuItem>
								)): (
									<MenuItem key={-1} value={-1}></MenuItem>
								)}
								</Select>
							</FormControl>
							</ThemeProvider>
							</CacheProvider>
							</Grid>

						</Grid>
					</Row>
					<Row lg="12" sm="12" style={{padding:'5px'}}>
						<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
							<Grid item xs={12} >
								<FormControl fullWidth variant="outlined">
									<OutlinedInput
										id="outlined-adornment-weight"
										fullWidth
										endAdornment={<SearchOutlinedIcon style={{marginLeft:'10px'}} position="end" />}
										aria-describedby="outlined-weight-helper-text"
										placeholder="جستجو"
										inputProps={{
											'aria-label': 'weight',
										}}
										value={searchTerm}
										onChange={handleSearch}
									/>
								</FormControl>
							</Grid>
						</Grid>
					</Row>

					<Row lg="12" sm="12" style={{padding:'5px',borderRadius:'10px', border: '1px solid #000000', marginBottom:'5px',marginTop:'5px'}}>
					<Grid container spacing={1} style={{direction:'rtl', textAlign:'right', maxHeight: '400px',overflowY:'auto', overflowX:'hidden'}} alignItems="center">
							{filteredExercises.map((card, index) => (
								<Grid item key={card.id} xs={12} sm={6} md={3} style={{ paddingRight: '8px', paddingTop: '8px' }}>

									<Card
										key={index}
										onClick={() => handleCardClick(card.id)}
										onMouseEnter={() => handleCardHover(card.id)}
										onMouseLeave={() => handleCardHover(null)}
									>
										<CardActionArea
											style={{
												border: isCardSelected(card.id) ? '2px solid red' : '2px solid transparent'
											}}
										>
											<CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
										<IconButton onClick={(e) => { e.stopPropagation(); openModalVideo2(card.video);}}>
										<PlayCircleFilledOutlinedIcon fontSize="inherit" style={{ color: '#278DEB',fontSize:'30px' }} />
										</IconButton>
											<CardMedia component="img" height="90" image={card.photo} alt="Card Image" />
												<Typography variant="body2" color="text.secondary">
												{hoveredCard === card.id ? card.name : (card.name.length <= 31 ? card.name : ("..." + card.name.substr(0, 25)))}
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</Grid>
							))}
						</Grid>
					</Row>

					<Row lg="12" sm="12" style={{padding:'5px',borderRadius:'10px'}}>
						<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">

							<Grid item lg={9} xs={12}>
								<FormControl fullWidth>
									<Select
										// labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={exersiceForm}
										// label="الگوهای تمرین ها"
										onChange={handleChangeExersiceForm}
										fullWidth={true}
										displayEmpty
										inputProps={{ 'aria-label': 'Without label' }}
										disabled={true}
									>
										<MenuItem key={-1} value={''}>
											الگوهای تمرین ها
										</MenuItem>
										<MenuItem value={10}>Crook lying</MenuItem>
										<MenuItem value={20}>Supine</MenuItem>

									</Select>
								</FormControl>
							</Grid>

							<Grid item lg={3} xs={12}>
								<Button
									variant="outlined"
									fullWidth={true}
									style={{backgroundColor:'#138C97' ,color:'white'}}
									onClick={() => {
										setBelowPage(true);
										setOpenModal2(false);
									}}
								>
									تایید
								</Button>
							</Grid>

						</Grid>
					</Row>

				</Box>
			</Modal>

			{/*Modal3*/}
			<Modal
				open={openModal3}
				onClose={handleCloseModal3}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={styleModal} className="wrapModal">
				<i className="tim-icons icon-simple-remove p-4 mt-2 font-weight-bold position-absolute close-modal"
                onClick={handleCloseModal3}></i>
					<Row lg="12" sm="12" style={{padding:'5px'}}>
						<Grid container spacing={1} style={{direction:'rtl', textAlign:'right', marginBottom:'10px'}} alignItems="center">

							<Grid item xs={12} >
								<Typography tag="h5" style={{color:'#138C97',fontWeight:'bold'}}>تاریخ</Typography>
							</Grid>

							{/*day--*/}
							<Grid item xs={4} >
								<Typography tag="subtitle1" style={{marginRight:'5px', fontSize:'15px', color:'#DD8E9C',fontWeight:'bold'}}>
									روز
								</Typography>
							</Grid>

							{/*month--*/}
							<Grid item xs={4} >
								<Typography tag="subtitle1" style={{marginRight:'5px', fontSize:'15px', color:'#DD8E9C',fontWeight:'bold'}}>
									ماه
								</Typography>
							</Grid>

							{/*year--*/}
							<Grid item xs={4} >
								<Typography tag="subtitle1" style={{marginRight:'5px', fontSize:'15px', color:'#DD8E9C',fontWeight:'bold'}}>
									سال
								</Typography>
							</Grid>

							{/*day*/}
							<Grid item xs={4} >
								<TextField
									select
									variant="outlined"
									fullWidth
									value={selectedDay}
									onChange={handleDayChange}
									InputLabelProps={{ shrink: true }}
									style={{fontFamily:'IranSans'}}
								>
									{generateDays().map((day) => (
										<MenuItem key={day} value={day}>
											{englishToPersianNumbers(day)}
										</MenuItem>
									))}
								</TextField>
							</Grid>

							{/*month*/}
							<Grid item xs={4} >
								<TextField
									select
									variant="outlined"
									fullWidth
									value={selectedMonth}
									onChange={handleMonthChange}
									InputLabelProps={{ shrink: true }}
								>
									{monthsArray.map((month,index) => (
										<MenuItem key={month.value} value={month.value}>
											{month.label}
										</MenuItem>
									))}
								</TextField>
							</Grid>

							{/*year*/}
							<Grid item xs={4} >
								<TextField
									select
									variant="outlined"
									fullWidth
									value={selectedYear}
									onChange={handleYearChange}
									InputLabelProps={{ shrink: true }}
								>
									{generateYears().map((year) => (
										<MenuItem key={year} value={year}>
											{englishToPersianNumbers(year)}
										</MenuItem>
									))}
								</TextField>
							</Grid>

						</Grid>
					</Row>

					<Row lg="12" sm="12" style={{padding:'5px'}}>
						<Grid container spacing={1} style={{direction:'rtl', textAlign:'right', marginBottom:'10px'}} alignItems="center">

							<Grid item xs={12} >
								<Typography tag="h5" style={{color:'#138C97',fontWeight:'bold'}}>زمان</Typography>
							</Grid>

							{/*min--*/}
							<Grid item xs={4} >
								<Typography tag="subtitle1" style={{marginRight:'5px', fontSize:'15px', color:'#DD8E9C',fontWeight:'bold'}}>
									دقیقه
								</Typography>
							</Grid>

							{/*month--*/}
							<Grid item xs={4} >
								<Typography tag="subtitle1" style={{marginRight:'5px', fontSize:'15px', color:'#DD8E9C',fontWeight:'bold'}}>
									ساعت
								</Typography>
							</Grid>

							{/*gap--*/}
							<Grid item xs={4} >

							</Grid>

							{/*min*/}
							<Grid item xs={4} >
								<TextField
									select
									variant="outlined"
									fullWidth
									value={selectedMinute}
									onChange={handleMinuteChange}
									InputLabelProps={{ shrink: true }}
								>
									{generateMin().map((min) => (
										<MenuItem key={min} value={min}>
											{englishToPersianNumbers(min)}
										</MenuItem>
									))}
								</TextField>
							</Grid>

							{/*hour*/}
							<Grid item xs={4} >
								<TextField
									select
									variant="outlined"
									fullWidth
									value={selectedHour}
									onChange={handleHourChange}
									InputLabelProps={{ shrink: true }}
								>
									{generateHour().map((hour,index) => (
										<MenuItem key={hour} value={hour}>
											{englishToPersianNumbers(hour)}
										</MenuItem>
									))}
								</TextField>
							</Grid>

							{/*gap*/}
							<Grid item xs={4} >

							</Grid>

						</Grid>
					</Row>

					<Row lg="12" sm="12" style={{padding:'5px'}}>
						<Grid container spacing={3} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
							<Grid item xs={10}>

							</Grid>
							<Grid itemlg={2} xs={12}>
								<Button
									variant="outlined"
									fullWidth={true}
									style={{backgroundColor:'#138C97' ,color:'white'}}
									onClick={() => {
										handleConfTime()
									}}
								>
									تایید
								</Button>
							</Grid>
						</Grid>
					</Row>

				</Box>
			</Modal>

			<div className="content">
				<Col lg="12" sm="12" style={{padding:'30px',borderRadius:'10px'}}>

					<Row lg="9" sm="9">
						<Card style={cardStyle} >

							<CardHeader className="text-right">
								<CardTitle tag="h3" style={{color:'#757575',fontWeight:'bold'}}>ویرایش جلسه</CardTitle>
							</CardHeader>

							<CardBody>
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">

									{/*تاریخ و زمان جلسه*/}
									<Grid item xs={12} >
										<Typography gutterBottom style={{color:'#EBAB60'}}>
											تاریخ و زمان جلسه
										</Typography>
									</Grid>

									<Grid item lg={2} xs={12}>

										<Button
											variant="outlined"
											fullWidth={true}
											style={{backgroundColor:'#138C97' ,color:'white'}}
											onClick={() => {
												handleOpenModal3()
											}}
										>
											انتخاب تاریخ و زمان
										</Button>
									</Grid>

									<Grid item lg={2} xs={12}>
										<Typography color='#757575' style={{marginRight:'10px'}}>
											{englishToPersianNumbersForDateTime(selectedHour)}:{englishToPersianNumbersForDateTime(selectedMinute)} - {englishToPersianNumbersForDateTime(selectedYear)}/{englishToPersianNumbersForDateTime(selectedMonth)}/{englishToPersianNumbersForDateTime(selectedDay)}
										</Typography>
									</Grid>

									{/*پرسشنامه*/}
									<Grid item xs={12} >
										<Typography gutterBottom style={{color:'#EBAB60'}}>
											پرسشنامه
										</Typography>
									</Grid>

									<Grid item lg={6} xs={12}>
										<RadioGroup
											row
											aria-labelledby="demo-row-radio-buttons-group-label"
											name="row-radio-buttons-group"
										>

											<FormControlLabel disabled={true} style={{marginLeft:'12px'}} value="have" control={<Radio style={{marginLeft:'10px'}} />} label="دارد" />
											<FormControlLabel disabled={true} value="donthave" control={<Radio style={{marginLeft:'10px'}}/>} label="ندارد" />

										</RadioGroup>
									</Grid>

									<Grid item xs={12}>
										<Divider style={{backgroundColor:'#000000'}} />
									</Grid>

									{/*تمرینات*/}
									<Grid item xs={12} >
										<Typography gutterBottom style={{color:'#EBAB60'}}>
											تمرینات
										</Typography>
									</Grid>

									{/*افزودن تمرینات*/}
									<Grid item lg={2} xs={12}>
										<Button
											variant="outlined"
											//fullWidth={true}
											startIcon={<ControlPointOutlinedIcon sx={{marginLeft:'10px',marginRight:'-10px' , color:'white'}}/>}
											style={{backgroundColor:'#138C97' ,color:'white'}}
											onClick={() => {
												koseSher()
												handleOpenModal()
												//props.viewInfo(true)
											}}
										>
											افزودن تمرینات
										</Button>
									</Grid>

									{/*طراحی تمرین جدید*/}
									<Grid item lg={3} xs={12}>
										<Button
											disabled={true}
											variant="outlined"
											//fullWidth={true}
											startIcon={<ControlPointOutlinedIcon sx={{marginLeft:'10px' ,marginRight:'-10px', color:'white'}}/>}
											// style={{backgroundColor:'#138C97' ,color:'white'}}
											style={{backgroundColor:"lightgrey" ,color:'white',marginRight:'-5px'}}
											onClick={() => {
												handleOpenModal()
												//props.viewInfo(true)
											}}
										>
											طراحی تمرین جدید
										</Button>
									</Grid>

								

									{/*افزودن از الگوهای تجویز برنامه*/}
									<Grid item lg={3} xs={12} style={{paddingLeft:'23px'}}>
										<Button
											variant="outlined"
											disabled={true}
											fullWidth={true}
											// startIcon={<ControlPointOutlinedIcon sx={{marginLeft:'10px' , color:'black'}}/>}
											startIcon={<ControlPointOutlinedIcon sx={{marginLeft:'10px',marginRight:'-10px' , color:'white'}}/>}
											//style={{backgroundColor:'#CCF1EA',color:'black'}}
											style={{backgroundColor:"lightgrey",color:'white'}}
											//onClick={() => props.viewInfo(true)}
										>
											افزودن از الگوهای تجویز برنامه
										</Button>
									</Grid>

											{/* set parameters */}
											<Grid item xs={12} hidden={!belowPage}>
										<Typography gutterBottom style={{ color: '#EBAB60' }}>
											تنظیم پارامترها
										</Typography>

									{/* apply to all or custom selected according*/}
									<Grid item xs={10}>
										<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right', padding: '10px' }} alignItems="center">

										{/* Sets */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography color='#757575'>تعداد ست*</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												fullWidth
												variant="outlined"
												rows={1}
												value={globalSetsValue}
												type="number"
												onChange={(event) => {setGlobalSetsValue(event.target.value)}}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Repeat */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography color='#757575'>تعداد تکرار*</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												fullWidth
												variant="outlined"
												rows={1}
												value={globalRepeatValue}
												type="number"
												onChange={(event) => setGlobalRepeatValue(event.target.value)}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Total Time */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography color='#757575'>زمان کل</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												fullWidth
												variant="outlined"
												placeholder={"ثانیه"}
												rows={1}
												value={globalTotalTimeValue}
												type="number"
												onChange={(event) => setGlobalTotalTimeValue(event.target.value)}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Hold Time */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography color='#757575'>زمان hold</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												fullWidth
												variant="outlined"
												placeholder={"ثانیه"}
												rows={1}
												value={globalHoldTimeValue}
												type="number"
												onChange={(event) => setGlobalHoldTimeValue(event.target.value)}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Rest Time */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography color='#757575'>زمان rest</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												fullWidth
												variant="outlined"
												placeholder={"ثانیه"}
												rows={1}
												value={globalRestTimeValue}
												type="number"
												onChange={(event) => {
													setGlobalRestTimeValue(event.target.value)}}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Tempo */}
										<Grid item lg={2} xs={12}>
											<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={12}>
												<Typography style={{color:'#a1a1a1'}}>تمپو</Typography>
											</Grid>
											<Grid item xs={12}>
												<TextField
												id="outlined-basic"
												disabled={true}
												fullWidth
												variant="outlined"
												rows={1}
												value={''}
												onChange={(event) => {}}
												/>
											</Grid>
											</Grid>
										</Grid>

										{/* Apply to selected */}
										<Grid item lg={3} xs={12}>
											<Button
											variant="outlined"
											style={{ backgroundColor: '#138C97', margin: '10px', color: 'white' }}
											fullWidth
											onClick={() => {
												const newParams = {
												sets: globalSetsValue,
												repeat: globalRepeatValue,
												total_time: globalTotalTimeValue,
												hold_time: globalHoldTimeValue,
												rest_time: globalRestTimeValue,
												};
												applyToSelected(newParams);
											}}
											>
											اعمال به موارد انتخاب شده
											</Button>
										</Grid>

										{/* Apply to all */}
										<Grid item lg={3} xs={12}>
											<Button
											variant="outlined"
											fullWidth
											onClick={() => {
												const newParams = {
													sets: globalSetsValue,
													repeat: globalRepeatValue,
													total_time: globalTotalTimeValue,
													hold_time: globalHoldTimeValue,
													rest_time: globalRestTimeValue,
												};
												applyToAll(newParams);
											}}
											>
											اعمال به همه موارد
											</Button>
										</Grid>
										</Grid>
										</Grid>
										{/*set params by according*/}
										<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">

											<Grid item xs={12}>
											<FormControlLabel
											control={<Checkbox checked={selectAllChecked} onChange={handleSelectAllChange} />}
											label="انتخاب همه"
										/>
												{selectedCards.map((accordion, index) => (
													<Accordion
													    defaultExpanded={true} // to by defualt open the all accordion
														key={accordion.id}
														style={{ marginTop: '10px', borderRadius: '10px', border: '1px solid #000000', borderColor: 'transparent' }}
													>
														<AccordionSummary
														className="d-flex align-items-center"
															expandIcon={<ExpandMoreIcon />}
															aria-controls={`panel${index + 1}-content`} id={`panel${index + 1}-header`}
														>
														<FormControlLabel
														control={<Checkbox 
															checked={selectedIndices.includes(index)}
															onChange={(e) => {
																const newSelectedIndices = e.target.checked
																	? [...selectedIndices, index]
																	: selectedIndices.filter(i => i !== index);
																setSelectedIndices(newSelectedIndices);
															}}
														onClick={(e) => e.stopPropagation()} />}
														label=""
														/>
															<Typography className="d-flex align-items-center" style={{marginRight:'20px', fontSize:'20px'}}>{accordion.name}</Typography>
														</AccordionSummary>
														<AccordionDetails className={classes.accordionDetails}>
															<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">

																{/*video*/}
																<Grid item lg={4} xs={12}>
																	<Grid container spacing={2} style={{ textAlign: 'center' }} alignItems="center">

																		<Grid item xs={12} style={{margin:'15px'}}>
																			{accordion.photo && (
																				<img
																					className={classes.image}
																					src={accordion.photo}
																					onContextMenu = {(e)=> e.preventDefault()}
																					alt="Exercise Image"
																				/>
																			)}

																		</Grid>

																		<Grid item xs={12}>
																			<IconButton aria-label="edit" size="large" onClick={() => openModalVideo2(accordion.video)}>
																				<PlayCircleFilledOutlinedIcon fontSize="inherit" style={{ color: '#278DEB',fontSize:'30px' }} />
																			</IconButton>

																		</Grid>
																	</Grid>

																</Grid>


																<Grid item lg={7} xs={12}>
																	<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">

																		{/*instruction*/}
																		<Grid item xs={12}>
																			<Typography variant='h6'>دستورالعمل انجام تمرین</Typography>
																		</Grid>

																		<Grid item xs={12}>
																			<TextField id="outlined-basic"
																			           fullWidth
																			           variant="outlined"
																			           multiline
																			           rows={4}
																			           value={accordion.instructions}
																			           onChange={(event) => {
																				           setExercises((prevExercises) => {
																					           const temp = [...prevExercises];
																					           temp[index].instructions = event.target.value;
																					           return temp;
																				           });
																			           }}
																			/>
																		</Grid>

																		<Grid item xs={12}>
																			<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">

																				{/*sets*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography color='#757575'>تعداد ست*</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           fullWidth
																							           variant="outlined"
																							           rows={1}
																							           value={sets[index]}
																							           type="number"
																							           onChange={(event) => {
																								           handleSetsChange(event.target.value,index)
																								           handleSet(index)( event.target.value)
																							           }}
																							/>
																						</Grid>
																					</Grid>
																				</Grid>

																				{/*repeat*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography color='#757575'>تعداد تکرار*</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           fullWidth
																							           variant="outlined"
																							           rows={1}
																							           value={repeat[index]}
																							           type="number"
																							           onChange={(event) => {
																								           handleRepeatChange(event.target.value,index)
																								           handleRepeat(index)( event.target.value)
																							           }}
																							/>
																						</Grid>
																					</Grid>
																				</Grid>

																				{/*total time*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography color='#757575'>زمان کل</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           fullWidth
																							           variant="outlined"
																							           placeholder={"ثانیه"}
																							           rows={1}
																							           value={totalTime[index]}
																							           type="number"
																							           onChange={(event) => {
																								           handleTotalChange(event.target.value,index)
																								           handleTotal(index)(event.target.value)
																							           }}
																							/>
																						</Grid>
																					</Grid>
																				</Grid>

																				{/*hold time*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography color='#757575'>زمان hold</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           fullWidth
																							           variant="outlined"
																							           placeholder={"ثانیه"}
																							           rows={1}
																							           value={holdTime[index]}
																							           type="number"
																							           onChange={(event) => {
																								           handleHoldChange(event.target.value,index)
																								           handleHold(index)(event.target.value)
																							           }}
																							/>
																						</Grid>
																					</Grid>
																				</Grid>

																				{/*rest time*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography color='#757575'>زمان rest</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           fullWidth
																							           variant="outlined"
																							           placeholder={"ثانیه"}
																							           rows={1}
																							           value={restTime[index]}
																							           type="number"
																							           onChange={(event) => {
																								           handleRestChange(event.target.value,index)
																								           handleRest(index)(event.target.value)
																							           }}
																							/>
																						</Grid>
																					</Grid>
																				</Grid>

																				{/*tempo*/}
																				<Grid item lg={2} xs={12}>
																					<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																						<Grid item xs={12}>
																							<Typography style={{color:'#a1a1a1'}}>تمپو</Typography>
																						</Grid>
																						<Grid item xs={12}>
																							<TextField id="outlined-basic"
																							           disabled={true}
																							           fullWidth
																							           variant="outlined"
																							           rows={1}
																							           value={accordion.tempo}
																							           onChange={(event) => {accordion.tempo = event.target.value}} />
																						</Grid>
																					</Grid>
																				</Grid>

																			</Grid>
																		</Grid>

																	</Grid>
																</Grid>

																{/*icons*/}
																<Grid item xs={12} lg={1}>
																	<Grid container style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
																		<Grid item xs={4} lg={12}>
																			<Tooltip title="حذف" variant="soft" arrow placement="left">
																				<IconButton aria-label="edit" size="large" onClick={() => {
							
																					handleDeleteExercise(accordion.id, index)}}>
																					<DeleteForeverIcon fontSize="inherit" style={{ color: '#D0576E',fontSize:'20px' }} />
																				</IconButton>
																			</Tooltip>
																		</Grid>
																		<Grid item xs={4} lg={12}>

																<IconButton disabled aria-label="edit" size="large" /*onClick={() => handleIconDelete(item.id)}*/>
																					<EditNoteOutlinedIcon fontSize="inherit" 
																					style={{ color: 'lightgray',fontSize:'20px' }}
																					// style={{ color: '#138C97',fontSize:'20px' }}
																					 />
																				</IconButton>
																		</Grid>
																		<Grid item xs={4} lg={12}>

																				<IconButton disabled aria-label="edit" size="large" 
																				>
																					<ContentCopyOutlinedIcon fontSize="inherit" 
																					// style={{ color: '#EBAB60',fontSize:'20px' }}
																					style={{ color: 'lightgray',fontSize:'20px' }}

																					 />
																				</IconButton>
																		</Grid>
																	</Grid>
																</Grid>

															</Grid>
														</AccordionDetails>
													</Accordion>
												))}
											</Grid>

											<Grid item xs={12}>
												<Divider/>
											</Grid>

											{/*note*/}
											<Grid item xs={12}>
												<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right', padding:'10px' }} alignItems="center">

													<Grid item xs={12}>
														<Typography gutterBottom style={{ color: '#EBAB60' }}>
															یادداشت
														</Typography>
													</Grid>

													<Grid item xs={12}>
														<TextField id="outlined-basic"
														           fullWidth
														           variant="outlined"
														           multiline
														           rows={4}
														           value={note}
														           onChange={(event) => {setNote(event.target.value)}}
														/>
													</Grid>

													<Grid item lg={1} xs={12}>
													<Button
															disabled={true}
															variant="outlined"
															fullWidth={true}
															startIcon={<LocalPrintshopOutlinedIcon sx={{marginLeft:'10px' , color:'white'}}/>}
															// style={{backgroundColor:'#CCF1EA' ,color:'black'}}
															style={{backgroundColor:"lightgrey" ,color:'white'}}


														>
															پرینت
														</Button>
													</Grid>
													<Grid item lg={3} xs={12}>
													<Button
														disabled={true}
															variant="outlined"
															fullWidth={true}
															startIcon={<BookmarksIcon sx={{marginLeft:'10px' , color:'white'}}/>}
															// style={{backgroundColor:'#CCF1EA' ,color:'black'}}
															style={{backgroundColor:"lightgrey",color:'white' }}

														>
															ذخیره الگوی تجویز برنامه
														</Button>
													</Grid>
													<Grid item lg={5} xs={12}>

													</Grid>
													<Grid item lg={1} xs={12}>
														<NavLink
															to={'/rtl/patientprofile'}
															//className="nav-link"
														>
															<Button
																variant="outlined"
																fullWidth={true}
																style={{backgroundColor:'#DD8E9C' ,color:'white'}}
															>
																بازگشت
															</Button>
														</NavLink>
													</Grid>
													<Grid item lg={2} xs={12}>
														<Button
															variant="outlined"
															fullWidth={true}
															style={{backgroundColor:'#138C97' ,color:'white'}}

															onClick={() => {
																handleSendToAPI()
															}}
														>
															تایید و ارسال
														</Button>
													</Grid>

												</Grid>
											</Grid>
										</Grid>
									</Grid>

									<Grid item xs={12} hidden={belowPage}>
										<Grid container style={{ direction: 'rtl', textAlign: 'right' }} >

											<Grid item xs={10}>

											</Grid>

											<Grid item lg={2} xs={12} style={{paddingRight:'40px'}}>
												<NavLink
													to={'/rtl/patientprofile'}
													className="nav-link"
													style={{direction:'rtl',textAlign:'left'}}
												>
													<Button
														variant="outlined"
														fullWidth
														style={{backgroundColor:'#DD8E9C' ,color:'white',}}

													>
														بازگشت
													</Button>
												</NavLink>

											</Grid>


										</Grid>
									</Grid>

								</Grid>
							</CardBody>
						</Card>
					</Row>

				</Col>
			</div>
		</>
	);
}

export default EditExersice;
